import React from 'react';
import { Box, Link, Popover, SpaceBetween } from '@amzn/awsui-components-core';
import './ChartInfoPopover.scss';

interface ChartInfoPopoverProps {
  /** Chart title, shown as the popover header. */
  title: string;
  /** One-line "what it shows" summary. */
  what: string;
  /** "How to read it" bullet points. */
  read: string[];
}

/**
 * Reusable "info" popover for a chart card header: a "What it shows" summary
 * plus a "How to read it" bullet list, triggered by an inline Info link.
 * Shared across the Canary charts so each card doesn't re-implement the layout.
 */
export const ChartInfoPopover: React.FC<ChartInfoPopoverProps> = ({ title, what, read }) => (
  <Popover
    header={title}
    position="top"
    size="large"
    triggerType="custom"
    dismissButton
    renderWithPortal
    content={
      <SpaceBetween size="s">
        <div>
          <Box variant="awsui-key-label">What it shows</Box>
          <Box variant="p" fontSize="body-s">
            {what}
          </Box>
        </div>
        <div>
          <Box variant="awsui-key-label">How to read it</Box>
          <ul className="chart-info-popover__list">
            {read.map((r, i) => (
              <li key={i} className="chart-info-popover__item">
                {r}
              </li>
            ))}
          </ul>
        </div>
      </SpaceBetween>
    }
  >
    <Link variant="info">Info</Link>
  </Popover>
);
